import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import {
  AdaptableDubaiIcon,
  ContinousDubaiIcon,
  TimelyDubaiIcon,
  AroundDubaiIcon,
} from "../../../app-constants";
function Techsolution(props) {
  return (
    <div className="techsolution tech_music_solution tech_hire_dubai p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>Why Hire Top Developers From TekRevol?</h2>
            <p>
              Unlock the benefits of hiring the best app developers with us and
              transform your business ideas into profitable solutions.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="">
            <div className="solution_box">
              <div className="solution_box_items">
                <div className="item_icon">{AdaptableDubaiIcon}</div>
                <div className="item_txt">
                  <h5>Adaptable Engagement Models</h5>
                  <p>
                    Choose the hiring model that suits your needs and budget.
                  </p>
                </div>
              </div>
              <div className="solution_box_items">
                <div className="item_icon">{AroundDubaiIcon}</div>
                <div className="item_txt">
                  <h5>Around-the-Clock Availability</h5>
                  <p>
                    Our app developers in Dubai are ready to work in any time
                    zone of your preference.
                  </p>
                </div>
              </div>
              <div className="solution_box_items">
                <div className="item_icon">{TimelyDubaiIcon}</div>
                <div className="item_txt">
                  <h5>Timely Project Completion </h5>
                  <p>
                    Ensure 100% timely deliveries leveraging cutting-edge
                    technologies & agile methodology.
                  </p>
                </div>
              </div>
              <div className="solution_box_items">
                <div className="item_icon">{ContinousDubaiIcon}</div>
                <div className="item_txt">
                  <h5>Continuous Maintenance</h5>
                  <p>
                    Benefit from reliable & dedicated support to assist you at
                    every stage of development & delivery.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Techsolution;
